// this file is automatically generated by git.version.ts script
export const versions = {
  version: '108191',
  revision: '',
  branch: 'master',
};
